import "./center-popup.css";
import { CenterPopup } from './center-popup';
export default CenterPopup;